import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { AuthAccessProvider } from '../core/core.auth';
import {
    UserContext, BaseComponent, Presence, PresenceResponse,
    PresenceDetailResponse, WorkedDateTime, User, UserInfo
} from '../core/core.component';
import { MessageProvider } from '../service/message.service';
import { PresenzeService } from '../service/presenze.service';
import { BusyProvider } from '../service/busy.service';
import { UserService } from '../service/user.service';
import { GlobalFilterService } from '../service/global-filter.service';
import { environment } from '../../environments/environment';
import { AppConstants } from '../core/app.constants';
import { SelectItem } from 'primeng/primeng';
import { Subject } from 'rxjs/Subject';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs';

declare var $: any;

@Component({
    selector: 'app-presences',
    templateUrl: './presences.component.html',
    styleUrls: ['./presences.component.css']
})
export class PresencesComponent extends BaseComponent implements OnInit, OnDestroy {
    static DIALOG_ID: string = "presenceDetailInfodialog";
    @Input() refresh: Subject<boolean>;
    @Input() isFullSize: boolean = false;
    it: any = AppConstants.ITA_CALENDAR_CONF;
    userContext: UserContext;
    presences: Presence[] = new Array();
    distinctDatePresences = new Map();
    dates: SummaryDatePresenceModel[] = [];
    usersSelected: SelectItem[] = [];
    users: User[] = [];
    filterUsers: SelectItem[] = [];
    filteredUsers: SelectItem[] = [];
    selectedGruppo:number=0;
    gruppiUsers: SelectItem[] = [];
    gruppi: SelectItem[]=[];
    utentiVisibili: SelectItem[]=[];
    
    filterUsernames: SelectItem[] = [];
    managedUsers: SelectItem[] = [];
    inactiveUsers = [];
    completed: boolean = false;
    showFilter: boolean = false;
    fromDate: Date = null;
    toDate: Date = null;
    @Output() fullSize = new EventEmitter<boolean>();
    @Output() onDelete = new EventEmitter<boolean>();
    workedTimeEffective: string = null;
    totalPresenceDays: number = 0;
    theoreticalRealTimeDiff: string = null;
    showDisclaimer: boolean = false;
    currentPresence: Presence = null;
    buttonLabel: string = "";
    buttonClickable: boolean = false;
    canUpdate: boolean = true;
    showDeleteAlert: boolean = false;
    rowsMode: string = "expanded";
    globalFilterSubscription: Subscription = null;
    
    numgruppi: number = null;
    detailInfo: Presence = null;

    userInfo: UserInfo;
    showUserColumn = false;

    usersGroupFilter = false;

    constructor(protected authAccess: AuthAccessProvider,
        protected router: Router,
        protected messageProvider: MessageProvider,
        private presenzeService: PresenzeService,
        private userService: UserService,
        private busyProvider: BusyProvider,
        private datePipe: DatePipe,
        private filterService: GlobalFilterService) {
        super(authAccess, router, messageProvider);
    }

    ngOnDestroy() {
        if (this.globalFilterSubscription != null) {
            this.globalFilterSubscription.unsubscribe();
        }
    }

    ngOnInit() {
        this.userContext = this.authAccess.getUserContext();
        this.fromDate = new Date();
        this.fromDate.setDate(1); // primo del mese
        this.toDate = new Date(); // data corrente

        this.refresh.asObservable().subscribe(value => { this.reload(); });

        this.userService.currentUserInfo(this.userContext.srmToken).subscribe(
            result => {
                this.userInfo = result;
                if (this.userInfo.managedUsers.length > 0 && this.userInfo.managedUsers.indexOf(this.userContext.userId) < 0) {
                    this.userInfo.managedUsers.push(this.userContext.userId);
                }
                const activeFilter = this.filterService.globalFilter.getValue();
                if (activeFilter) {
                    this.fromDate = activeFilter.dateFrom;
                    this.toDate = activeFilter.dateTo;
                    if (this.userInfo.admin || this.userInfo.managedUsers.length > 0) {
                        this.usersSelected = activeFilter.users;
                        this.utentiVisibili = activeFilter.users;
                        this.usersGroupFilter = activeFilter.usersGroupFilter;
                    }
                }
                if (this.userInfo.admin || this.userInfo.managedUsers.length > 0) {
                    this.initFilterUsers();
                } else {
                    this.search(false);
                }
                this.gruppi=[];
                this.numgruppi=0;
                    this.gruppi.push({ label: "Tutti i gruppi", value: this.numgruppi });
                    for (const key in this.userInfo.managedUsersMap) {
                        this.numgruppi++;
                        this.gruppi.push({ label: key, value: this.numgruppi });
                        
                    }

                
            },
            error => {
                this.handleError(error);
            }
        );

        this.globalFilterSubscription = this.filterService.getGlobalFilter().subscribe(
            filter => {
                if (!filter) return;
                this.fromDate = filter.dateFrom;
                this.toDate = filter.dateTo;
                if (this.userInfo && (this.userInfo.admin || this.userInfo.managedUsers.length > 0)) {
                    this.usersSelected = filter.users;
                    this.utentiVisibili=filter.users;
                    this.usersGroupFilter = filter.usersGroupFilter;
                }
                if (this.userInfo) this.reload();
            }
        );
    }

    private initFilterUsers() {
        if (!this.userInfo.admin && this.userInfo.managedUsers.length == 0) {
            return;
        }
        this.userService.getUsers(this.userContext.srmToken, false).subscribe(
            result => {
                this.users = result.users;
                for (var i = 0; i < result.users.length; ++i) {
                    var current: User = result.users[i];
                    if (this.userInfo.admin || this.userInfo.managedUsers.indexOf(current.username.toLowerCase()) != -1) {
                        this.filterUsers.push({ label: current.fullname, value: current.id });
                        this.filterUsernames.push({ label: current.username, value: current.id });
                        this.gruppiUsers.push({ label: this.getGruppoUser(current), value: current.id});
                        if (!current.active) {
                            this.inactiveUsers.push(current.id);
                        }
                    }
                    
                }
                for (var i = 0; i < this.filterUsers.length; i++) {
                                
                    if (this.userInfo.managedUsers.some(user => this.filterUsernames[i].label.toLowerCase().includes(user.toLowerCase())))
                        this.managedUsers.push(this.filterUsers[i]);
                }

                this.search(false);
            },
            error => {
                this.handleError(error);
            }
        );
    }

    private search(switchFilter: boolean) {
        this.completed = false;
        this.presences = [];
        this.distinctDatePresences.clear();
        this.dates = [];
        this.messageProvider.clearAll();
        this.canUpdate = this.userInfo.admin || this.usersSelected.length == 0;
        var response: PresenceResponse;

        this.showUserColumn = this.userInfo.admin || (this.userInfo.managedUsers.length > 0 && this.usersSelected.length > 0);

        let usersId: number[] = [];
        for (let i = 0; i < this.utentiVisibili.length; ++i) {
            usersId.push(this.utentiVisibili[i].value);
        }

        if (usersId.length == 0 && !this.userInfo.admin) {
            usersId.push(0);
        }
        if (usersId.length == 0 && this.userInfo.admin) {
            for (let i = 0; i < this.filterUsers.length; ++i) {
                usersId.push(this.filterUsers[i].value);
            }
        }

        this.presenzeService.getPresencesPeriod(this.userContext.srmToken, this.fromDate, this.toDate, usersId).subscribe(
            result => {
                response = result;
                this.presences = response.presences;
                this.fillFullname(this.presences);
                this.presences = this.presences.reverse();

                this.groupPresenceByDate();
                this.workedTimeEffective = AppConstants.formatDuration(response.totalDurationHours, response.totalDurationMinutes);
                this.totalPresenceDays = this.distinctDatePresences.size;
                this.completed = true;
                if (switchFilter && this.presences.length != 0) {
                    this.toggleFilter();
                }
                if (usersId.length <= 1) {
                    // new 
                    if (this.dates.length != 0) {

                        let dStart: Date = null;
                        let dEnd: Date = null;

                        if (this.dates.length == 1) {
                            dStart = this.dates[0].date;
                            dEnd = this.dates[0].date;
                        }
                        else {
                            // dates è ordinato in modo decrescente per cui la data 
                            // di inizio periodo si trova come ultimo elemento
                            dEnd = this.dates[0].date;
                            dStart = this.dates[this.dates.length - 1].date;
                            this.presenzeService.timeworkedByRange(this.userContext.srmToken, dStart, dEnd, usersId[0]).subscribe(
                                result => {
                                    let totalDurationHours = 0;
                                    let theoreticalTotalDurationHours = 0;
                                    for (let i = 0; i < result.result.length; ++i) {
                                        let current: WorkedDateTime = result.result[i];
                                        let currentDataString = this.datePipe.transform(current.date, "yyyy-MM-dd");
                                        for (let j = 0; j < this.dates.length; ++j) {
                                            let otherDataString = this.datePipe.transform(this.dates[j].date, "yyyy-MM-dd");
                                            if (currentDataString == otherDataString) {
                                                this.dates[j].timeToString = AppConstants.formatDuration(current.hours, current.minutes);
                                                this.dates[j].color = current.hours < current.theoreticalTime ? "#843534" : "#3c763d";
                                                this.dates[j].icon = current.hours < current.theoreticalTime ? "glyphicon glyphicon-thumbs-down" : "glyphicon glyphicon-thumbs-up";
                                                totalDurationHours += current.hours + current.minutes / 60;
                                                theoreticalTotalDurationHours += current.theoreticalTime;
                                                break;
                                            }
                                        }
                                    }
                                    if (!this.userInfo.admin) {
                                        const diff = totalDurationHours - theoreticalTotalDurationHours;
                                        this.theoreticalRealTimeDiff = (diff < 0 ? '-' : '') + AppConstants.formatDuration(Math.floor(Math.abs(diff)), Math.abs(Math.abs(diff) - Math.floor(Math.abs(diff))) * 60);
                                    }
                                },
                                error => {
                                    this.completed = true;
                                    this.handleError(error);
                                });
                        }
                    } //
                }
            },
            error => {
                this.completed = true;
                this.handleError(error);
            });
    }




    private groupPresenceByDate() {
        if (this.presences == null || this.presences.length == 0) {
            return;
        }
        // le date sono già raggruppate e ordinate
        let date = this.presences[0].begin;
        let dateString = this.datePipe.transform(date, "dd/MM/yyyy");

        let result: Presence[] = [];
        for (let i = 0; i < this.presences.length; ++i) {
            let _date = this.datePipe.transform(this.presences[i].begin, "dd/MM/yyyy");
            if (_date != dateString) {
                result = this.sort(result);
                this.distinctDatePresences.set(dateString, result);
                let summaryDate = new SummaryDatePresenceModel();
                summaryDate.date = date;
                summaryDate.dateToString = dateString;
                this.dates.push(summaryDate);
                // reset
                dateString = _date;
                date = this.presences[i].begin;
                result = [];
            }
            result.push(this.presences[i]);
        }
        // aggiunge ultima data
        result = this.sort(result);
        this.distinctDatePresences.set(dateString, result);
        let summaryDate = new SummaryDatePresenceModel();
        summaryDate.date = date;
        summaryDate.dateToString = dateString;
        this.dates.push(summaryDate);
    }


    private fillFullname(presences: Presence[]) {
        for (let i = 0; i < presences.length; ++i) {
            let presence = presences[i];
            for (let j = 0; j < this.filterUsers.length; ++j) {
                if (this.filterUsers[j].value == presence.userId) {
                    presence.fullName = this.filterUsers[j].label;
                    break;
                }
            }
        }
    }

    

    filterUser(event) {
        this.filteredUsers = AppConstants.filterSuggestions(this.filterUsers, event.query, item => [item.label]);
    }

    reload() {
        this.search(false);
    }

    toggleFilter() {
        this.showFilter = !this.showFilter;
    }

    toggleRowDate(index) {
        $("tr[id='" + index + "']").toggle();

    }

    toggleAllRow(open: boolean) {
        for (let i = 0; i < this.dates.length; ++i) {
            if (open) {
                $("tr[id='" + this.dates[i].dateToString + "']").show();
            } else {
                $("tr[id='" + this.dates[i].dateToString + "']").hide();
            }
        }
        this.rowsMode = this.rowsMode == "expanded" ? "collapsed" : "expanded";
    }

    applyFilter() {
        this.search(true);
    }

    setFullSize() {
        this.fullSize.emit(true);
        this.isFullSize = true;
    }
    resize() {
        this.fullSize.emit(false);
        this.isFullSize = false;
    }

    openDetail(presence: Presence) {
        this.presenzeService.openPresenceDetail(presence == null ? this.currentPresence : presence);
    }

    openMoreInfo(presence: Presence) {
        let resp: PresenceDetailResponse = null;
        this.presenzeService.getPresenceDetailInfo(this.userContext.srmToken, presence.id).
            subscribe(
                result => {
                    resp = result;
                    this.detailInfo = resp.presence;
                    let found: number = 0;
                    for (let i = 0; i < this.users.length; ++i) {
                        if (found == 2) {
                            break;
                        }
                        if (this.detailInfo.userId == this.users[i].id) {
                            this.detailInfo.fullName = this.users[i].fullname;
                            ++found;
                        }
                        if (this.detailInfo.amenderUserId == this.users[i].id) {
                            this.detailInfo.amenderFullname = this.users[i].fullname;
                            ++found;
                        }
                    }
                    $("#" + PresencesComponent.DIALOG_ID).modal({ backdrop: 'static', keyboard: false });
                },
                error => {
                    this.handleError(error);
                }
            );
    }

    closeMoreInfo() {
        $("#" + PresencesComponent.DIALOG_ID).modal("hide");
        this.detailInfo = null;
    }

    openDetailFormAdmin() {
        this.presenzeService.openPresenceDetail(new Presence());
    }

    deletePresence() {
        this.messageProvider.clearAll();
        this.busyProvider.showBusyIndicator();
        this.presenzeService.deletePresence(this.userContext.srmToken, this.currentPresence.id).subscribe(
            result => {
                this.currentPresence = null;
                this.busyProvider.hideBusyIndicator();
                this.onDelete.emit(true);
                this.messageProvider.notifyMessage("Presenza Eliminata");
            },
            error => {
                this.currentPresence = null;
                this.busyProvider.hideBusyIndicator();
                this.handleError(error);
            }
        );
    }

    sort(presencesDate: Presence[]): Presence[] {
        presencesDate = presencesDate.sort((p1, p2) => {
            if (p1.fullName == p2.fullName) {
                let ingresso1 = this.datePipe.transform(p1.begin, "HH:mm");
                let ingresso2 = this.datePipe.transform(p2.begin, "HH:mm");
                return ingresso1 > ingresso2 ? 1 : -1;
            }
            return p1.fullName > p2.fullName ? 1 : -1;
        });
        return presencesDate;
    }

    openDisclaimer(presence?: Presence) {
        this.currentPresence = new Presence();
        if (presence != null && typeof (presence) != 'undefined') {
            this.currentPresence = presence;
        }
        this.showDisclaimer = true;
        let timer = Observable.timer(5, 1000);
        let subscriptionTimer: Subscription;
        let counter: number = environment.PRESENZE_DELAY;
        this.buttonLabel = "Attendi " + counter + " secondi";
        subscriptionTimer = timer.subscribe(
            t => {
                this.buttonLabel = "Attendi " + counter + " secondi";
                --counter;
                if (counter == -1) {
                    this.buttonLabel = "Sono Consapevole";
                    this.buttonClickable = true;
                    subscriptionTimer.unsubscribe();
                }
            });
    }

    closeDisclaimer() {
        this.showDisclaimer = false;
        this.buttonClickable = false;
        this.buttonLabel = "";
    }

    openDeleteAlert(currentPresence: Presence) {
        this.currentPresence = currentPresence;
        this.showDeleteAlert = true;
    }
    closeDeleteAlert() {
        this.showDeleteAlert = false;
    }


    applyUsersGroupFilter() {
        this.usersSelected = [];
        this.usersGroupFilter = !this.usersGroupFilter;

        if (this.usersGroupFilter) {
            
            for (let i = 0; i < this.filterUsers.length; i++) {
                if ((this.inactiveUsers.indexOf(this.filterUsers[i].value) == -1) && this.userInfo.managedUsers.some(user => this.filterUsers[i].label.toLowerCase().includes(user.toLowerCase()))){
                
                    this.usersSelected.push(this.filterUsers[i]);
                    
                }
                

            }
            if (this.gruppi.length==2)
                this.selectedGruppo=1;
            this.filterUtentiGruppi();
        }
        else
            this.utentiVisibili=[];
    }

    getGruppo(id: number): string | null {
        const gruppo = this.gruppi.find(userGroup => userGroup.value === id);
        if (gruppo) {
            return gruppo.label;
        }
        return null;
    }


    filterUtentiGruppi (){
        
        this.utentiVisibili = [];
        if (this.selectedGruppo==0){
            this.utentiVisibili=this.managedUsers;
        }
        else{
            const usernames = this.userInfo.managedUsersMap[this.getGruppo(this.selectedGruppo)];
            
        if (Array.isArray(usernames)) {
            for (let username of usernames) {
                const user = this.filterUsernames.find(u => 
                    u.label.toLowerCase().includes(username.toLowerCase()) 
                );
                if (user) {
                    let item=this.filterUsers.find(u => 
                        u.value == user.value)
                    this.utentiVisibili.push({ label: item.label, value: item.value });
                }
        }
        }

    }}

    getGruppoUser(utente: User): string | null {
        if (!this.userInfo || !this.userInfo.managedUsersMap) return null;
        
        const managedUsersMap = this.userInfo.managedUsersMap;
        
        for (const key in managedUsersMap) {
            if (Object.prototype.hasOwnProperty.call(managedUsersMap, key)) {
                const value = managedUsersMap[key];
                if (Array.isArray(value) && value.some(v => v.toLowerCase() === utente.username.toLowerCase())) {
                    return key;
                }
            }
        }
        return null;
    }

}

export class SummaryDatePresenceModel {
    date: Date = null;
    dateToString: string = null;
    timeToString: string = null;
    color: string = "";
    icon: string = "";

    constructor() { }
}




// WEBPACK FOOTER //
// ./src/app/presences/presences.component.ts